import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'

export const USER_GUIDES_URL =
	'https://medisis.notion.site/MediSis-Gu-as-de-usuario-2a4a16e895a980409006cd98d333137f'

export function UserGuidesLink() {
	return (
		<Link
			to={USER_GUIDES_URL}
			target="_blank"
			rel="noopener noreferrer"
			className="relative inline-flex items-center justify-center rounded-md p-2 text-navbar-foreground transition-colors hover:text-primary focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-navbar"
			aria-label="Guías de usuario"
			title="Guías de usuario"
		>
			<Icon name="question-mark-circled" size="md" />
		</Link>
	)
}
